import React, { useState, useEffect, useRef, useMemo } from "react";
import { Card } from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import UploadService from "../../../../services/FileUploadService";
import BootstrapTable from "react-bootstrap-table-next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useSnackbar } from "react-simple-snackbar";
import * as actions from "../../_redux/products/productsActions";

import { useProductsUIContext } from "../products/ProductsUIContext";
export function InvoiceFileUpload() {
  const dispatch = useDispatch();

  const productsUIContext = useProductsUIContext();
  const productsUIProps = useMemo(() => {
    return {
      ids: productsUIContext.ids,
      queryParams: productsUIContext.queryParams,
      setQueryParams: productsUIContext.setQueryParams,
      newProductButtonClick: productsUIContext.newProductButtonClick,
      openDeleteProductsDialog: productsUIContext.openDeleteProductsDialog,
      openEditProductPage: productsUIContext.openEditProductPage,
      openUpdateProductsStatusDialog:
        productsUIContext.openUpdateProductsStatusDialog,
      openFetchProductsDialog: productsUIContext.openFetchProductsDialog,
    };
  }, [productsUIContext]);

  const inputFile = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState("");
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState({});
  const [accountingSoftwares, setAccountingSoftwares] = useState(null);
  const [accountingSoftwareType, setAccountingSoftwareType] = useState(null);
  const [previewFile, setPreviewFile] = useState(undefined);
  const [resultsPreviewFile, setResultsPreviewFile] = useState(undefined);

  const [lastTemplate, setLastTemplate] = useState(undefined);

  const [fields, setFields] = useState({
    customerCode: "",
    duns: "",
    sum: "",
    date: "",
    invoiceId: "",
    customerName: "",
    columnDelimiter: ",",
    template: true,
    fileAsHeaders: true,
  });

  let resultsPreviewColumns = [
    {
      dataField: "customerCode",
      text: "customer code",
    },
    {
      dataField: "customerName",
      text: "customer name",
    },
    {
      dataField: "duns",
      text: "Duns",
    },
    {
      dataField: "date",
      text: "date",
    },
    {
      dataField: "invoiceId",
      text: "invoice id",
    },
    {
      dataField: "sum",
      text: "amount",
    },
  ];

  const numericresultsPreviewColumns = [
    {
      dataField: "1",
      text: "customer code",
    },
    {
      dataField: "2",
      text: "customer name",
    },
    {
      dataField: "3",
      text: "Duns",
    },
    {
      dataField: "4",
      text: "date",
    },
    {
      dataField: "5",
      text: "invoice id",
    },
    {
      dataField: "6",
      text: "amount",
    },
  ];
  const [previewColumns, setPreviewColumns] = useState({});
  const [isUnmappedFilePreview, setisUnmappedFilePreview] = useState(false);

  const [previewSkipRows, setPreviewSkipRows] = useState(0);
  const [previewUntilRow, setPreviewUntilRow] = useState(20);

  function loadIsTemplate() {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}invoice-file-mapping-template`)
      .then((response) => response.data)
      .then((d) => {
        if (d && d[0]) {
          setFields({
            ...fields,
            ...d[0].template,
            templateName: d[0].name,
          });

          setLastTemplate(d[0].template);
        } else {
          setLastTemplate(fields);

          if (accountingSoftwares) {
            setAccountingSoftwareType(accountingSoftwares[0].type);
            loadAccountingSoftwareFields(accountingSoftwares[0].type);
          } else {
            axios
              .get(`${process.env.REACT_APP_API_BASE_URL}accounting-software`)
              .then((response) => response.data)
              .then((res) => {
                setAccountingSoftwares(res);
                setAccountingSoftwareType(res[0].type);
                loadAccountingSoftwareFields(res[0].type);
              });
          }
        }
      });
  }

  const selectFile = (event) => {
    event.preventDefault();
    setSelectedFiles(event.target.files);
    setCurrentFile(event.target.files[0]);
  };
  const accountingSoftwareChanged = (event) => {
    setAccountingSoftwareType(event.target.value);
    loadAccountingSoftwareFields(event.target.value);
  };
  const previewUntilRowChanged = (event) => {
    if (event == "") event = 20;

    setPreviewUntilRow(event);
  };
  const separatorChanged = (event) => {
    if (event == "") event = 20;

    //setPreviewUntilRow(event);
  };
  const previewSkipRowsChanged = (event) => {
    if (event == "") event = 0;

    setPreviewSkipRows(event);
  };
  function loadAccountingSoftwareFields(accountingSoftwareType) {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}accounting-software-invoice-fields/${accountingSoftwareType}`
      )
      .then((response) => response.data)
      .then((f) => {
        setFields({ ...fields, ...f });
      });
  }

  useEffect(() => {
    if (previewFile) {
      getResultsPreview();
    }
  }, [fields, previewFile]);

  function getResultsPreview() {
    let lastUnmappedFile = sessionStorage.getItem("lastUnmappedFile");

    if (
      ((selectedFiles == undefined || selectedFiles.length == 0) &&
        (lastUnmappedFile == undefined || lastUnmappedFile == null)) ||
      fields.columnDelimiter == ""
    ) {
      return;
    }

    let custom_mapping = fields;

    let formData = new FormData();

    formData.append("accounting_software_type", accountingSoftwareType);
    formData.append("skipLines", previewSkipRows);
    formData.append("untilLine", previewUntilRow);

    formData.append("custom_mapping", JSON.stringify(custom_mapping));

    if (lastUnmappedFile != undefined && lastUnmappedFile != null)
      formData.append("cloudFileUrl", lastUnmappedFile);
    else {
      formData.append("files", selectedFiles[0]);
    }
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}file-result-preview`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(function(response) {
        if (response.data.response.length > 0) {
          setResultsPreviewFile(response.data.response);
        } else {
          setResultsPreviewFile([]);
        }
      });
  }

  function previewExcelDetails() {
    let lastUnmappedFile = sessionStorage.getItem("lastUnmappedFile");

    if (
      (selectedFiles == undefined || selectedFiles.length == 0) &&
      (lastUnmappedFile == undefined || lastUnmappedFile == null)
    ) {
      return;
    }

    let formData = new FormData();

    formData.append("accounting_software_type", accountingSoftwareType);
    formData.append("skipLines", previewSkipRows);
    formData.append("untilLine", previewUntilRow);

    formData.append("custom_mapping", JSON.stringify(fields));

    if (lastUnmappedFile != undefined && lastUnmappedFile != null)
      formData.append("cloudFileUrl", lastUnmappedFile);
    else {
      formData.append("files", selectedFiles[0]);
    }
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}file-preview`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function(response) {
        if (response.data.response.length > 0) {
          let objectKeys = Object.keys(response.data.response[0]);
          // objectKeys = objectKeys[0].split(/\s+/);
          let colsArray = new Array();

          for (let index = 0; index < objectKeys.length; index++) {
            colsArray.push({
              dataField: objectKeys[index],
              text: objectKeys[index],
            });
          }

          setPreviewColumns(colsArray);
          setPreviewFile(response.data.response);

          // let objectKeys2 = Object.keys(response.data.response[0]);
          // objectKeys2 = objectKeys2[0].split(/\s+/);
          // let colsArray2 = new Array();

          // for (let index = 0; index < objectKeys2.length; index++) {
          //   colsArray2.push({
          //     dataField: objectKeys2[index],
          //     text: objectKeys2[index],
          //   });
          // }

          // setPreviewColumns(colsArray2);
          // setPreviewFile(response.data.response);
          //     setPreviewFile
        } else {
          setPreviewColumns([]);
          setPreviewFile([]);
        }
      });
    //    .then((response) => response.data.response)
    // .then((response) => setPreviewFile(response.map((r, index) => ({ ...r, _id: index }))));
  }

  useEffect(() => {
    previewExcelDetails();
  }, [previewUntilRow, previewSkipRows, fields]);

  useEffect(() => {
    let lastUnmappedFile = sessionStorage.getItem("lastUnmappedFile");
    if (lastUnmappedFile != undefined && lastUnmappedFile != null) {
      setisUnmappedFilePreview(true);

      previewExcelDetails();
    }
  }, []); // Or [] if effect doesn't need props or state

  useEffect(() => {
    selectedFiles && previewExcelDetails();
  }, [selectedFiles]);

  function onMappingFormChange(key, value) {
    setFields({ ...fields, [key]: value });
  }

  function onFileHasHeadersCHanged(value) {
    if (value === false) {
      setFields({
        customerCode: "1",
        duns: "2",
        sum: "3",
        date: "4",
        invoiceId: "5",
        customerName: "6",
        columnDelimiter: fields.columnDelimiter,
        template: fields.template,
        fileAsHeaders: false,
      });
      resultsPreviewColumns = numericresultsPreviewColumns;
    } else {
      lastTemplate.fileAsHeaders = value;
      setFields(lastTemplate);
      resultsPreviewColumns = resultsPreviewColumns;
    }
  }

  const upload = () => {
    let currentFile = selectedFiles[0];
    setProgress(0);
    setMessage({});
    setCurrentFile(currentFile);
    UploadService.upload(
      currentFile,
      "invoice-upload",
      accountingSoftwareType,
      fields,

      (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      }
    )
      .then((response) => {
        displayUploadSummery(response);
        dispatch(actions.fetchProducts(productsUIProps.queryParams));
        return response;
      })
      .catch(() => {
        setProgress(0);
        //   setMessage("Could not upload the file!");
        setCurrentFile(undefined);
      });

    // setSelectedFiles(undefined);
  };
  const displayUploadSummery = (serverResponse) => {
    if (serverResponse != undefined && serverResponse.data != undefined) {
      let msg = {};
      msg.newInvoices = serverResponse.data.added.length;
      msg.customersWithNoTaxId = serverResponse.data.customersWithNoTaxId;
      msg.closedinvoices = serverResponse.data.closedinvoices;

      setMessage(msg);
      setCurrentFile(undefined);
    }

    setProgress(0);
  };

  const saveTemplateAndProcess = () => {
    let lastUnmappedFile = sessionStorage.getItem("lastUnmappedFile");
    let data = {
      cloudFileUrl: lastUnmappedFile,
      custom_mapping: JSON.stringify(fields),
    };

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}process-cloud-invoice-file`,
        data
      )

      .then((response) => {
        displayUploadSummery(response);
        dispatch(actions.fetchProducts(productsUIProps.queryParams));
      })
      .catch((error) => {});
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}accounting-software`)
      .then((response) => response.data)
      .then((res) => {
        setAccountingSoftwares(res);
        setAccountingSoftwareType(res[0].type);
      })
      .then(() => {});
  }, []); // Or [] if effect doesn't need props or state

  useEffect(() => {
    loadIsTemplate();
  }, []);

  return (
    <Card>
      <div className="container">
        <div className="row padding-top">
          <div className="col">
            {isUnmappedFilePreview && <h3>Match file template</h3>}
            {!isUnmappedFilePreview && <h3>Upload new trade document</h3>}
          </div>
        </div>
        <div
          className="padding-top flex-row d-flex"
          style={{ padding: "auto 252px" }}
        >
          {!isUnmappedFilePreview && (
            <div className="d-flex">
              <label className="btn btn-default upload-btn">
                <input type="file" ref={inputFile} onChange={selectFile} />
              </label>
            </div>
          )}
          {accountingSoftwares && !isUnmappedFilePreview && (
            <div className="flex-grow-1 d-flex align-items-center justify-content-start flex-row ml-10 mr-10">
              <label className="mr-3">Accounting software</label>
              <select
                className="custom-select"
                style={{ maxWidth: "300px" }}
                onChange={accountingSoftwareChanged}
              >
                {accountingSoftwares.map((accountingSoftware) => (
                  <option
                    key={accountingSoftware.type}
                    value={accountingSoftware.type}
                  >
                    {accountingSoftware.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          {!isUnmappedFilePreview && (
            <div className="d-flex">
              <button
                className="btn btn-success float-right"
                disabled={!selectedFiles}
                onClick={upload}
              >
                Upload
                <span className="svg-icon-sm svg-icon-primary ml-3">
                  <SVG
                    width="15px"
                    height="15px"
                    src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")}
                  ></SVG>
                </span>
              </button>
            </div>
          )}
        </div>
        {message.newInvoices != undefined && (
          <>
            <div
              style={{ marginTop: "10PX" }}
              class="alert alert-success"
              role="alert"
            >
              New invoices: {message.newInvoices}
            </div>

            <div class="alert alert-danger" role="alert">
              Customers With No TaxId {message.customersWithNoTaxId}
            </div>
            <div class="alert alert-info" role="alert">
              Closed invoices {message.closedinvoices}
            </div>
          </>
        )}

        {isUnmappedFilePreview && (
          <div className="row mt-5">
            <button
              className="btn btn-success float-right"
              onClick={saveTemplateAndProcess}
            >
              Save Template And Process
              <span className="svg-icon-sm svg-icon-primary ml-3">
                <SVG
                  width="15px"
                  height="15px"
                  src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")}
                ></SVG>
              </span>
            </button>
          </div>
        )}
      </div>

      <form className="padding-top-0">
        <div className="row">
          <div className="col">
            <h4>Fields Mapping</h4>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <label className="checkbox checkbox-single">
              <input
                type="checkbox"
                className="form-control checkbox"
                checked={fields.fileAsHeaders || false}
                onChange={(e) => onFileHasHeadersCHanged(e.target.checked)}
              />
              <span className="mr-3 ml-3" />
              file as headers
            </label>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <label>customer Code</label>
            <input
              type="text"
              className="form-control"
              value={fields.customerCode}
              placeholder="customer Code"
              onChange={(e) =>
                onMappingFormChange("customerCode", e.target.value)
              }
            />
          </div>
          <div className="col">
            <label>Duns</label>
            <input
              type="text"
              className="form-control"
              value={fields.duns}
              placeholder="Duns"
              onChange={(e) => onMappingFormChange("duns", e.target.value)}
            />
          </div>
          <div className="col">
            <label>Amount</label>
            <input
              type="text"
              className="form-control"
              value={fields.sum}
              placeholder="Amount"
              onChange={(e) => onMappingFormChange("sum", e.target.value)}
            />
          </div>
          <div className="col">
            <label>Date</label>
            <input
              type="text"
              className="form-control"
              value={fields.date}
              placeholder="Date"
              onChange={(e) => onMappingFormChange("date", e.target.value)}
            />
          </div>
          <div className="col">
            <label>invoice Id</label>
            <input
              type="text"
              className="form-control"
              value={fields.invoiceId}
              placeholder="invoice Id"
              onChange={(e) => onMappingFormChange("invoiceId", e.target.value)}
            />
          </div>
          <div className="col">
            <label>Customer Name</label>
            <input
              type="text"
              className="form-control"
              value={fields.customerName}
              placeholder="Customer Name"
              onChange={(e) =>
                onMappingFormChange("customerName", e.target.value)
              }
            />
          </div>
        </div>
        {/* <div className="row mt-5">
          {fields.template && !isUnmappedFilePreview && (
            <div className="d-flex mr-5">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-control checkbox"
                  checked={fields.template || false}
                  onChange={(e) =>
                    onMappingFormChange("template", e.target.checked)
                  }
                />
                <span className="mr-3 ml-3" />
                save as a template
              </label>
            </div>
          )}
          {fields.template && !isUnmappedFilePreview && (
            <div className="d-flex flex-row">
              <label className="checkbox checkbox-single">template name</label>
              <input
                type="text"
                className="form-control"
                value={fields.templateName}
                placeholder="template name"
                onChange={(e) =>
                  onMappingFormChange("templateName", e.target.value)
                }
              />
            </div>
          )}
        </div> */}
        {previewFile && (
          <div className="row mt-5">
            <h3>Preview file</h3>
          </div>
        )}
        {previewFile && (
          <div className="row mt-5">
            <div className="col">
              <label>Skip Rows</label>
              <input
                type="text"
                className="form-control"
                placeholder="Skip Rows"
                onKeyUp={(e) => previewSkipRowsChanged(e.target.value)}
              />
            </div>
            <div className="col">
              <label>Until Row</label>
              <input
                type="text"
                className="form-control"
                placeholder="Until Row"
                onKeyUp={(e) => previewUntilRowChanged(e.target.value)}
              />
            </div>
            <div className="col">
              <label>Column Separator</label>
              <input
                type="text"
                className="form-control"
                maxLength="1"
                value={fields.columnDelimiter}
                placeholder="Column Separator"
                onChange={(e) =>
                  onMappingFormChange("columnDelimiter", e.target.value)
                }
              />
            </div>
          </div>
        )}
        {resultsPreviewFile && (
          <div className="row mt-5">
            <h3>Preview Results</h3>
          </div>
        )}
        {resultsPreviewFile && (
          <div className="row mt-5">
            <BootstrapTable
              wrapperClasses="table-responsive"
              bordered={false}
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              remote
              keyField={"_id"}
              data={resultsPreviewFile.filter((val, i) => i < 5)}
              columns={resultsPreviewColumns}
            />
          </div>
        )}
        {previewFile && (
          <div className="row mt-5">
            <h3>Raw Preview</h3>
          </div>
        )}
        {previewFile && (
          <div className="row mt-5">
            <BootstrapTable
              wrapperClasses="table-responsive"
              bordered={false}
              classes="table table-vertical-center overflow-hidden"
              bootstrap4
              remote
              keyField={"_id"}
              data={previewFile}
              columns={previewColumns}
            />
          </div>
        )}
      </form>
    </Card>
  );
}
